/**
 * Inbox page for coach chat.
 */
import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import VText from "form/VText";
import { asNumber } from "utils/safeData";
import ChatContent from "./chat.content";
import ChatUserInfo from "./chat.userinfo";

/**
 * Lays out coach info and the message thread at a viewport-based height.
 */
const Chat = () => {
  const { t } = useTranslation("common");

  const [contentHeight, setContentHeight] = useState(500);

  useEffect(() => {
    const titleHeight = asNumber(document.getElementById("v-chat-title")?.offsetHeight);
    const totalHeight = asNumber(document.body?.offsetHeight);
    setContentHeight(Math.max(asNumber(totalHeight - titleHeight - 77 - 48 - 90), 0));
  }, []);

  return (
    <Box className="flex-1 md:p-6">
      <Box className="flex flex-col md:rounded-xl h-full v-bg-body">
        <Box className="px-6 py-8" id="v-chat-title">
          <Grid container spacing={2}>
            <Grid item sm={12} className="flex">
              <VText color="secondary" className="text-2xl">
                {t("Inbox")}
              </VText>
            </Grid>
          </Grid>
        </Box>

        <Box className="flex-1 flex flex-col md:flex-row h-auto md:h-full">
          <ChatUserInfo />
          <ChatContent height={contentHeight} />
        </Box>
      </Box>
    </Box>
  );
};

export default Chat;
